import styled from 'styled-components';

export const TableContainer = styled.div`
  width: 100%;
  overflow-x: auto;
  margin: 20px 0;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
`;

export const TableHead = styled.thead`
  background-color: #f8f9fa;
`;

export const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }
`;

export const TableCell = styled.td`
  padding: 12px;
  border: 1px solid #dee2e6;
  text-align: left;
  font-size: 14px;
  color: #495057;

  &:first-child {
    font-weight: bold;
  }
`;

export const TableBody = styled.tbody`
  background-color: #fff;
`;

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 20px 0;
`;

export const PaginationButton = styled.button`
  background-color: ${props => props.theme.colors.primary};
  color: ${props => props.theme.colors.onColor};
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: ${props => props.theme.colors.primaryHover};
  }

  &:disabled {
    background-color: ${props => props.theme.colors.textMuted};
    cursor: not-allowed;
  }
`;

export const EmptyStateContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 40px 20px;
  background-color: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 6px;
  margin: 20px 0;
`;

export const EmptyStateText = styled.p`
  color: #6c757d;
  font-size: 16px;
  margin: 0;
  text-align: center;
`;

export const EmptyStateSubtext = styled.p`
  color: #adb5bd;
  font-size: 14px;
  margin: 8px 0 0 0;
  text-align: center;
`;
